<template>
  <div class="rightAll">
    <div class="rightAll-form">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item :label="$t('common.num')">
          <el-select
            v-model="formInline.selectCarType"
            style="width: 120px"
            :placeholder="$t('common.form.choseTip')"
            class="selectStyle"
          >
            <el-option
              v-for="item in optionsInput"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-input
            size="mini"
            v-model="formInline.selectCarValue"
            :placeholder="$t('common.searchTip')"
            style="width: 150px"
            class="inputStyle"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('VehicleManagement.state')">
          <el-select
            v-model="formInline.maintainState"
            :placeholder="$t('VehicleManagement.form.chooseMaintainType')"
            style="width: 150px"
          >
            <el-option :label="$t('common.all')" value=""></el-option>
            <el-option :label="$t('common.normal')" value="0"></el-option>
            <el-option :label="$t('common.nearTime')" value="1"></el-option>
            <el-option :label="$t('common.exceedTime')" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            size="mini"
            type="primary"
            @click="onSearch"
            class="btn-chaxun"
            >{{ $t("common.btn.search") }}</el-button
          >
          <el-button size="mini" @click="onClear" class="btn-del">{{
            $t("common.btn.cancel")
          }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="rightAll-btn">
      <el-button
        v-if="isPrimaryKey('MAINTENANCEREMINDER_MAINTAIN')"
        type="text"
        @click="addReminder"
        :disabled="selected.length != 1"
        >{{ $t("VehicleManagement.serial") }}</el-button
      >
    </div>
    <i-table
      :list="list"
      :height="height"
      ref="carTable"
      @handleSelectionChange="handleSelectionChange"
      :options="option"
      :columns="columns"
      :operates="operates"
    ></i-table>
    <IPagination ref="page" @PageFun="changeSize"></IPagination>
    <el-dialog
      width="620px"
      :before-close="closeDia"
      class="addDialong"
      :title="diaTitle"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :rules="rules" ref="form" :model="form">
        <el-form-item
          prop="carId"
          :label="$t('common.carId') + ':'"
          :label-width="formLabelWidth"
        >
          <el-input
            size="small"
            v-model="form.carId"
            autocomplete="off"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="operateUser"
          :label="$t('VehicleManagement.serialPerson') + ':'"
          :label-width="formLabelWidth"
        >
          <el-input
            size="small"
            v-model="form.operateUser"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="operateTime"
          :label="$t('VehicleManagement.serialTime') + ':'"
          :label-width="formLabelWidth"
        >
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            :placeholder="$t('common.btn.choseDate')"
            v-model="form.operateTime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          prop="remarks"
          :label="$t('common.remark') + ':'"
          :label-width="formLabelWidth"
        >
          <el-input
            size="small"
            v-model="form.remarks"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="peopleCost"
          :label="$t('VehicleManagement.peopleCost') + ':'"
          :label-width="formLabelWidth"
        >
          <el-input
            size="small"
            v-model="form.peopleCost"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="filePath"
          :label="$t('EquipmentRenewal.uploadFiles') + ':'"
          :label-width="formLabelWidth"
          style="margin-top: 20px"
        >
          <el-upload
            class="upload-demo"
            :action="processImg"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :before-upload="beforeUpload"
            :limit="1"
            :file-list="FileList"
          >
            <el-button size="small" type="primary"> {{ $t('common.btn.clickUpload') }}</el-button>
            <div slot="tip" class="el-upload__tip">{{ $t('common.btn.onlyUploadpdfOrimg') }}</div>
          </el-upload>
          <!-- <el-upload
            class="avatar-uploader"
            :action="processImg"
            list-type="picture-card"
            :file-list="FileList"
            :limit="4"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog
            :visible.sync="dialogVisible"
            append-to-body
            class="imgForm"
          >
            <img width="100%" :src="imageUrl" alt="" class="avatar" />
          </el-dialog> -->
        </el-form-item>
        <el-form-item
          prop="maintainProject"
          :label="$t('NavMenu.MaintenanceProgram') + ':'"
          :label-width="formLabelWidth"
        >
          <el-button @click="changeProject">{{ btnName }}</el-button>
        </el-form-item>
        <el-form-item
          prop="maintainPropose"
          :label="$t('VehicleManagement.maintenanceSuggestions') + ':'"
          :label-width="formLabelWidth"
        >
          <el-input
            size="small"
            v-model="form.maintainPropose"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <div style="margin-top: 10px; font-size: 16px">
          {{ $t("VehicleManagement.replaceParts") }}
        </div>
        <partsRow ref="diaTable" @computedPrice="computedPrice"></partsRow>
        <p style="text-align: right">
          {{ $t("VehicleManagement.totalMoneny") }}{{ form.materialCost }}
        </p>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancle('form')">{{
          $t("common.btn.cancel")
        }}</el-button>
        <el-button size="small" type="primary" @click="submitForm('form')">{{
          $t("common.btn.confirm")
        }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      width="800px"
      :before-close="closeProjectDia"
      class="tableDialong"
      title="保养项目"
      :visible.sync="dialogProjectFormVisible"
      :close-on-click-modal="false"
    >
      <div class="zMsgTable">
        <el-table
          height="400px"
          :data="tableData"
          :span-method="objectSpanMethod"
          border
          stripe
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column
            align="center"
            prop="project"
            label="项目"
            width="180"
          >
          </el-table-column>
          <el-table-column
            label="序号"
            type="index"
            :index="indexMethod"
            align="center"
            width="50"
          ></el-table-column>
          <el-table-column align="center" prop="projectName" label="检查内容">
          </el-table-column>
          <el-table-column align="center" label="检查结果" prop="projectOption">
            <template slot-scope="scope">
              <el-radio v-model="scope.row.projectOption" label="0" @change="changeRadio('0',scope.row)">良</el-radio>
              <el-radio v-model="scope.row.projectOption" label="1" @change="changeRadio('1',scope.row)">差</el-radio>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancleProject">{{
          $t("common.btn.cancel")
        }}</el-button>
        <el-button size="small" type="primary" @click="submitProject">{{
          $t("common.btn.confirm")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MaintenanceReminder from "./MaintenanceReminder.js";
export default MaintenanceReminder;
</script>

<style lang="less" scoped>
@import "../../../../assets/styles/Style.less";
</style>
